<template>
  <div>
    <!--Header Components-->
    <base-header class="pb-6" type="">
      <b-row class="align-items-center py-4">
        <b-col lg="12" cols="12">
          <!-- <h6 class="h2 text-white d-inline-block mb-0">{{$route.name}}</h6> -->
          <h6 class="h2 d-inline-block mb-0">{{ language_terms[$route.name] }}</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-breadcrumb />
          </nav>
        </b-col>
      </b-row>
    </base-header>

    <b-container fluid class="mt--6">
      <b-row>
        <div>
          <loading :active.sync="loading" 
            color= '#007bff'
            :width= '128'
            :height= '128'
            loader='dots'
            :can-cancel="true" 
            :is-full-page="true">
          </loading>
        </div>
      </b-row>
      <b-row>
        <b-col lg="12">
          <div class="card-wrapper">
            <!-- Input groups -->
            <card>
              <!-- Card header -->
              <!-- <h3 slot="header" class="mb-0">{{language_terms['QUICK_SEARCH']}}</h3> -->
                <div slot="header" class="mb-0">
                  <b-row>
                    <b-col cols="8">
                        <h3>{{language_terms['QUICK_SEARCH']}}</h3>
                    </b-col>
                    <b-col :cols="module == 'rfids' ? 2: 4">
                       <base-button type="success" @click="newAction" class="float-right">
                          <i class="fa fa-plus"></i>
                          <!-- <span v-if="module != 'glvouchers'">{{language_terms['NEW']}}</span> {{title}} -->
                        </base-button>
                    </b-col>
                    <b-col :cols="module == 'rfids' ? 2: 4" v-if="module == 'rfids'">
                        <base-button type="primary" @click="uploadRFID">
                        <i class="fa fa-upload"></i>
                          {{language_terms['UPLOAD']}} {{title}}
                        </base-button>
                    </b-col>
                  </b-row>
                </div>
              <!-- Card body -->
              <!-- Input groups with icon -->
              <b-row>
                <b-col md="9">
                  <base-input
                    :label="language_terms['KEYWORD']"
                    :placeholder="language_terms['KEYWORD_INFO']"
                    v-on:keyup.enter="clickOnSearch"
                    v-model="filter.keyword">
                    <template slot="append">
                      <i
                        class="fas fa-search"
                        @click="clickOnSearch"
                        style="cursor: pointer"
                      ></i>
                    </template>
                  </base-input>
                  </b-col>
                  <b-col md="2">
                    <base-input :label="language_terms['ACTIVE_ONLY']">
                      <el-select v-model="filter.active_only" :placeholder="language_terms['ACTIVE_ONLY']" >
                        <el-option
                          v-for="item in activeOptions"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                    </base-input>

                  </b-col>
                  <b-col cols="1" class='mt-4'>
                    <base-button type="primary" @click.native="clickOnSearch" class='mt-2'>{{language_terms['SEARCH']}}</base-button>
                  </b-col>
              </b-row>
              <!-- <b-row>
                <b-col cols="12">
                  <base-button type="primary" @click="clickOnSearch">{{language_terms['SEARCH']}}</base-button>
                  <base-button type="darkGreen" @click="clickOnReset">{{language_terms['RESET']}}</base-button>
                </b-col>
              </b-row> -->
            </card>
            <!-- Search Results -->
            <PaginatedTables
              :myColumns="tableColumns"
              :tableData="items"
              :cardTitle="language_terms['SEARCH_RESULTS']"
              v-if="items.length > 0"
            />
          </div>
        </b-col>
      </b-row>
      <!-- <a href="javascript:void(0)" class="float" @click="newAction">
        <i class="fa fa-plus my-float"></i>
      </a> -->

    </b-container>
  </div>
</template>

<script>
import { Select, Option, Dropdowns } from "element-ui";
import TagsInput from "@/components/Inputs/TagsInput";
import BaseSlider from "@/components/BaseSlider";
import PaginatedTables from "@/views/Tables/PaginatedTables";
import { mapState } from "vuex";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
export default {
      props:{
        module:{
          type:String,
          default:""
        },
        tableColumns:{
            required:true,
            type:Array,
            default: function () { return [] },
        },
        addNew:{
          type: String,
          description: 'Add New product',
          required:true
        },
  },
  name: "masterList",
  components: {
    Loading,
    TagsInput,
    BaseSlider,
    [Select.name]: Select,
    [Option.name]: Option,
    PaginatedTables,
  },
  computed: {
    ...mapState({
      employee_filter: (state) => state.employees.filter,
      customer_filter: (state) => state.customers.filter,
      vendor_filter: (state) => state.vendors.filter,
      product_filter: (state) => state.products.filter,
      voucher_filter: (state) => state.vouchers.voucher_filter,
      gl_voucher_filter: (state) => state.vouchers.gl_voucher_filter,
      vouchers: (state) => state.vouchers.vouchers,
      case_types_filter: (state) => state.caseTypes.filter,
      case_types: (state) => state.caseTypes.case_types,
      gl_vouchers: (state) => state.vouchers.gl_vouchers,
      salechannel_filter: (state) => state.salechannels.filter,
      location_filter: (state) => state.locations.filter,
      user_filter:(state) => state.users.filter,
      customers: (state) => state.customers.customers,
      employees: (state) => state.employees.employees,
      users: (state) => state.users.users,
      vendors: (state) => state.vendors.vendors,
      products: (state) => state.products.products,
      locations: (state) => state.locations.locations,
      salechannels: (state) => state.salechannels.salechannels,
      language_terms: (state) => state.languages.language_terms,
      selected_lang: (state) => state.languages.selected_langauge,
      contact_categories: (state) => state.contactCategories.contact_categories,
      contact_category_filter: (state) => state.contactCategories.filter,
      system_settings: (state) => state.systemSettings.system_settings,
      system_setting_filter: (state) => state.systemSettings.filter,
      assets: (state) => state.assets.assets,
      assets_filter: (state) => state.assets.filter,
      rfids: (state) => state.rfids.rfids,
      rfids_filter: (state) => state.rfids.filter,
      asset_classifications: (state) => state.assetClassifications.asset_classifications,
      asset_classification_filter: (state) => state.assetClassifications.filter,
      asset_protocols: (state) => state.assetProtocols.asset_protocols,
      asset_protocol_filter: (state) => state.assetProtocols.filter,
    }),
  },
  data() {
    return {
      fullPage: true,
      loading:false,
      activeValue: "",
      items:[],
      title:null,
      activeOptions: [
        {
          value: "1",
          label: "Yes",
        },
        {
          value: "0",
          label: "No",
        },
      ],
      filter:{
        keyword:"",
        active_only:"1"
      }
    };
  },
  watch:{
    module(newVal)
    {
      if(newVal == 'customers')
      {
        this.items = this.customers
        this.filter = this.customer_filter
        this.title = this.language_terms['CUSTOMER']
      }
      else if (newVal == 'employees')
      {
        this.items = this.employees
        this.filter = this.employee_filter
        this.title = this.language_terms['EMPLOYEE']
      }
      else if(newVal == 'vendors')
      {
        this.items = this.vendors
        this.filter = this.vendor_filter
        this.title = this.language_terms['VENDOR']
      }
      else if(newVal == 'products')
      {
        this.items = this.products
        this.filter = this.product_filter
        this.title = this.language_terms['PRODUCT']

      }
      else if(newVal == 'salechannels')
      {
        this.items = this.salechannels
        this.filter = this.salechannel_filter
        this.title = this.language_terms['SALE_CHANNEL']
      }
      else if(newVal == 'locations')
      {
        this.items = this.locations
        this.filter = this.location_filter
        this.title = this.language_terms['LOCATION']
      }
      else if(newVal == 'users')
      {
        this.items = this.users
        this.filter = this.user_filter
        this.title = this.language_terms['LOCATION']
      }
      else if(newVal == 'vouchers')
      {
        this.items = this.vouchers
        this.filter = this.voucher_filter
        this.title = this.language_terms['VOUCHER']
      }
      else if(newVal == 'glvouchers')
      {
        this.items = this.gl_vouchers
        this.filter = this.gl_voucher_filter
        this.title = this.language_terms['NEW_GL_VOUCHER']
      }
      else if(newVal == 'caseTypes')
      {
        this.items = this.case_types
        this.filter = this.case_types_filter
        this.title = this.language_terms['CASE_TYPE']
      }
      else if(newVal == 'contactCategories')
      {
        this.items = this.contact_categories
        this.filter = this.contact_category_filter
        this.title = this.language_terms['CONTACT_CATEGORY']
      }
      else if(newVal == 'systemSettings')
      {
        this.items = this.system_settings
        this.filter = this.system_setting_filter
        this.title = this.language_terms['SYSTEM_SETTING']
      }
      else if(newVal == 'assets')
      {
        this.items = this.assets
        this.filter = this.assets_filter
        this.title = this.language_terms['ASSETS']
      }
      else if(newVal == 'rfids')
      {
        this.items = this.rfids
        this.filter = this.rfids_filter
        this.title = this.language_terms['RFIDS']
      }
      else if(newVal == 'assetClassifications')
      {
        this.items = this.asset_classifications
        this.filter = this.asset_classification_filter
        this.title = this.language_terms['ASSET_CLASSIFICATIONS']
      }
      else if(newVal == 'assetProtocols')
      {
        this.items = this.asset_protocols
        this.filter = this.asset_protocol_filter
        this.title = this.language_terms['ASSET_PROTOCOLS']
      }
    }
  },
  mounted(){
      if(this.module == 'customers')
      {
        this.items = this.customers
        this.filter = this.customer_filter
        this.title = this.language_terms['CUSTOMER']
      }
      else if(this.module == 'employees')
      {
        this.items = this.employees
        this.filter = this.employee_filter
        this.title = this.language_terms['EMPLOYEE']
      }
      else if(this.module == 'vendors')
      {
        this.items = this.vendors
        this.filter = this.vendor_filter
        this.title = this.language_terms['VENDOR']
      }
      else if(this.module == 'products')
      {
        this.items = this.products
        this.filter = this.product_filter
        this.title = this.language_terms['PRODUCT']
      }
      else if(this.module == 'salechannels')
      {
        this.items = this.salechannels
        this.filter = this.salechannel_filter
        this.title = this.language_terms['SALE_CHANNEL']
      }
      else if(this.module == 'locations')
      {
        this.items = this.locations
        this.filter = this.location_filter
        this.title = this.language_terms['LOCATION']
      }
      else if(this.module == 'users')
      {
        this.items = this.users
        this.filter = this.user_filter
        this.title = this.language_terms['USER']
      }
      else if(this.module == 'vouchers')
      {
        this.items = this.vouchers
        this.filter = this.voucher_filter
        this.title = this.language_terms['VOUCHER']
      }
      else if(this.module == 'glvouchers')
      {
        this.items = this.gl_vouchers
        this.filter = this.voucher_filter
        this.title = this.title = this.language_terms['NEW_GL_VOUCHER']
      }
      else if(this.module  == 'caseTypes')
      {
        this.items = this.case_types
        this.filter = this.case_types_filter
        this.title = this.language_terms['CASE_TYPE']
      }
      else if(this.module  == 'contactCategories')
      {
        this.items = this.contact_categories
        this.filter = this.contact_category_filter
        this.title = this.language_terms['CONTACT_CATEGORY']
      }
      else if(this.module == 'systemSettings')
      {
        this.items = this.system_settings
        this.filter = this.system_setting_filter
        this.title = this.language_terms['SYSTEM_SETTING']
      }
      else if(this.module == 'assets')
      {
        this.items = this.assets
        this.filter = this.assets_filter
        this.title = this.language_terms['ASSETS']
      }
      else if(this.module == 'rfids')
      {
        this.items = this.rfids
        this.filter = this.rfids_filter
        this.title = this.language_terms['RFIDS']
      }
      else if(this.module == 'assetClassifications')
      {
        this.items = this.asset_classifications
        this.filter = this.asset_classification_filter
        this.title = this.language_terms['ASSET_CLASSIFICATIONS']
      }
      else if(this.module == 'assetProtocols')
      {
        this.items = this.asset_protocols
        this.filter = this.asset_protocol_filter
        this.title = this.language_terms['ASSET_PROTOCOLS']
      }
  },
  methods: {
    uploadRFID()
    {
       this.loading = true
       this.$router.push("/rfids/upload-file")
       this.loading = false
    },
    newAction() 
    {
      this.loading=true
      this.$router.push(this.$props.addNew);
      this.loading =false
    },
    async clickOnSearch() 
    {
      this.loading = true;

      if(this.module == 'vouchers')
      {
        await this.$store.dispatch("vouchers/quickSearch", this.filter)

      }
      else if(this.module == 'glvouchers')
      {
        this.filter.type = 'GL'
        await this.$store.dispatch("vouchers/quickSearch", this.filter)
      }
      else
      {
        await this.$store.dispatch(`${this.module}/quickSearch`, this.filter)
      }

      if(this.module == 'customers')
      {
        this.items = this.customers
      }
      else if(this.module == 'employees')
      {
        this.items = this.employees
      }
      else if(this.module == 'products')
      {
        this.items = this.products
      }
      else if(this.module == 'salechannels')
      {
        this.items = this.salechannels
      }
      else if(this.module == 'locations')
      {
        this.items = this.locations
      }
      else if(this.module == 'vendors')
      {
        this.items = this.vendors
      }
      else if(this.module == 'users')
      {
        this.items = this.users
      }
      else if(this.module == 'vouchers')
      {
        this.items = this.vouchers
      }
      else if(this.module == 'glvouchers')
      {
        this.items = this.gl_vouchers
      }
      else if(this.module == 'caseTypes')
      {
        this.items = this.case_types
      }
      else if(this.module == 'contactCategories')
      {
        this.items = this.contact_categories
      }
      else if(this.module == 'systemSettings')
      {
        this.items = this.system_settings
      }
      else if(this.module == 'assets')
      {
        this.items = this.assets
      }
      else if(this.module == 'rfids')
      {
        this.items = this.rfids
      }
      else if(this.module == 'assetClassifications')
      {
        this.items = this.asset_classifications
      }
      else if(this.module == 'assetProtocols')
      {
        this.items = this.asset_protocols
      }
      this.loading = false;
    },
    async clickOnReset(){

    } 
    
  },
};
</script>

